import React from 'react';
import DrillCardFlipper from './DrillCardFlipper';
import { Drill } from '@/components/drill-library/types/drill-types';
import { TagPreference } from '@/components/drill-library/types/drill-types';

interface DrillLibraryPanelProps {
    drills: Drill[];
    tagPreferences: { [key: string]: TagPreference };
    onDrillSelect: (drillId: string) => void;
    onDrillDrag: (drillId: string) => void;
    onDrillDragEnd: () => void;
    leftColumns?: number; // Number of columns allocated to left panel
    selectedDrillId?: string | null;
    onSelectDrillCandidate?: (drillId: string) => void;
    onTagClick?: (tag: string) => void;
    onAddDrill?: (drillId: string) => void;
    nextSlotLabel?: string;
}

const DrillLibraryPanel: React.FC<DrillLibraryPanelProps> = ({
    drills,
    tagPreferences,
    onDrillSelect,
    onDrillDrag,
    onDrillDragEnd,
    leftColumns = 3,
    selectedDrillId,
    onSelectDrillCandidate,
    onTagClick,
    onAddDrill,
    nextSlotLabel
}) => {
    // Calculate visible cards based on column width (max 3)
    const visibleCards = Math.max(1, Math.min(3, leftColumns));

    return (
        <div className="h-full flex flex-col">
            {/* Drill Cards Display */}
            <div className="flex-1 overflow-hidden">
                <DrillCardFlipper
                    drills={drills}
                    tagPreferences={tagPreferences}
                    onDrillSelect={onDrillSelect}
                    onDrillDrag={onDrillDrag}
                    onDrillDragEnd={onDrillDragEnd}
                    visibleCards={visibleCards}
                    selectedDrillId={selectedDrillId}
                    onSelectDrillCandidate={onSelectDrillCandidate}
                    onTagClick={onTagClick}
                    onAddDrill={onAddDrill}
                    nextSlotLabel={nextSlotLabel}
                />
            </div>
        </div>
    );
};

export default DrillLibraryPanel;